'use client';
import { Typography } from './Typography.mjs';

const TypographyStylesProvider = Typography;

export { Typography, TypographyStylesProvider };
//# sourceMappingURL=index.mjs.map
